import { withRouter } from 'react-router-dom';

const enhancer = withRouter;
export default enhancer;
